
import { useEffect, useState } from 'react';
import {Tooltip, Button, OverlayTrigger} from "react-bootstrap";
import {CopyToClipboard} from "react-copy-to-clipboard";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

export function TooltipWithCopy({text, buttonText, showAsButton = true, small = false}) {
    const [isCopied, setCopied] = useState(false);

    useEffect(() => {
        function simulateNetworkRequest() {
            return new Promise((resolve) => setTimeout(resolve, 1500));
        }

        if (isCopied) {
            simulateNetworkRequest().then(() => {
                setCopied(false);
            });
        }
    }, [isCopied]);

    const handleClick = () => setCopied(true);

    // Text mode: show text with copy icon
    if (!showAsButton) {
        return (
            <OverlayTrigger
                delay={{ hide: 450, show: 300 }}
                overlay={(props) => (
                    <Tooltip {...props}>
                        {isCopied ? 'Copied!' : 'Click to copy'}
                    </Tooltip>
                )}
                placement="bottom"
            >
                <CopyToClipboard text={text}>
                    <span
                        onClick={handleClick}
                        style={{
                            cursor: 'pointer',
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '4px',
                            ...(small ? { fontSize: '0.8em' } : {})
                        }}
                    >
                        {text}
                        <ContentCopyIcon style={{ fontSize: small ? '12px' : '16px', color: isCopied ? 'green' : 'inherit' }} />
                    </span>
                </CopyToClipboard>
            </OverlayTrigger>
        );
    }

    // Button mode: show button (default/original behavior)
    return (
        <div>
            <OverlayTrigger
                delay={{ hide: 450, show: 300 }}
                overlay={(props) => (
                    <Tooltip {...props}>
                        {text}
                    </Tooltip>
                )}
                placement="bottom"
            >
                <CopyToClipboard text={text}>
                    <Button
                        disabled={isCopied}
                        onClick={!isCopied ? handleClick : null}
                    >
                        {isCopied ? 'Copied!' : buttonText}
                    </Button>
                </CopyToClipboard>
            </OverlayTrigger>
        </div>
    );
}